// Estado global del rastreo (compartir ubicación). Ver CLAUDE.md §7.
//
// Ya NO lo enciende el repartidor: ShiftBeacon llama a start()/stop() según tenga o
// no entregas "en ruta"/"en sitio". Aquí solo vive el estado y la marca de tiempo en
// localStorage, que sirve para el corte de seguridad de 16h.
// (Los nombres siguen diciendo "shift" por herencia de DS Field, donde sí era un
// turno manual; renombrarlo todo sería puro ruido.)
import { create } from 'zustand'

export const SHIFT_KEY = 'hotel-depot:shiftStartedAt'
export const MAX_SHIFT_MS = 16 * 60 * 60 * 1000 // 16h: evita rastreo indefinido

export function readPersistedShift(): boolean {
  try {
    const v = localStorage.getItem(SHIFT_KEY)
    if (!v) return false
    const started = Date.parse(v)
    if (Number.isNaN(started) || Date.now() - started > MAX_SHIFT_MS) {
      localStorage.removeItem(SHIFT_KEY)
      return false
    }
    return true
  } catch {
    return false
  }
}

interface ShiftState {
  sharing: boolean
  error: string | null
  /** Lo registra el beacon para poder avisar shift_end ANTES de cerrar el socket. */
  _sendEnd: (() => void) | null
  registerEndSender: (fn: (() => void) | null) => void
  setError: (e: string | null) => void
  start: () => void
  stop: () => void
}

export const useShiftStore = create<ShiftState>((set, get) => ({
  sharing: readPersistedShift(),
  error: null,
  _sendEnd: null,
  registerEndSender: (fn) => set({ _sendEnd: fn }),
  setError: (e) => set({ error: e }),
  start: () => {
    try {
      localStorage.setItem(SHIFT_KEY, new Date().toISOString())
    } catch {
      /* sin almacenamiento: el turno no persistirá, pero funciona */
    }
    set({ sharing: true, error: null })
  },
  stop: () => {
    get()._sendEnd?.() // avisa a los mapas antes de que el beacon cierre el socket
    try {
      localStorage.removeItem(SHIFT_KEY)
    } catch {
      /* ignora */
    }
    set({ sharing: false, error: null })
  },
}))
